import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress, Snackbar, Alert, MenuItem, IconButton, Tabs, Tab } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { fetchEmployees, addEmployee } from "../services/Employee/EmployeeApi";
import { fetchActiveBranches } from "../services/apiServiceDashboard";
import { getAllUsers } from "../services/Users";
import EditeEmployeeData from "../components/PagesComponents/EmployeePage/EditeEmployeeData";
// NEW: استيراد مكون كشف الحساب
import EmployeeAccountStatement from "../components/PagesComponents/EmployeePage/EmployeeAccountStatement";


const EmployeePage = () => {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  const [open, setOpen] = useState(false);
  const [newStaff, setNewStaff] = useState({ name: "", role: "", status: "نشط" });
  const [employeeForm, setEmployeeForm] = useState({
    name: "",
    email: "",
    address: "",
    phone: "",
    role: "",
    monthly_salary: "",
    weekly_salary: "",
    daily_salary: "",
    salary_type: "monthly",
    user_id: "",
    root_id: "",
    nationa_id: null,
  });
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  // NEW: قائمة الفروع وخريطة id->name
  const [branches, setBranches] = useState([]);
  const [branchesMap, setBranchesMap] = useState({});

  // NEW: قائمة المستخدمين وخريطة id->اسم المستخدم
  const [users, setUsers] = useState([]);
  const [usersMap, setUsersMap] = useState({});

  // NEW: حالة فتح نافذة التعديل ومعرف الموظف المحدد
  const [editOpen, setEditOpen] = useState(false);
  const [editEmployeeId, setEditEmployeeId] = useState(null);

  // NEW: حالة كشف حساب الموظف
  const [accountOpen, setAccountOpen] = useState(false);
  const [accountEmployeeId, setAccountEmployeeId] = useState(null);

  // NEW: تفاصيل عرض بيانات الموظف الكاملة
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);

  // NEW: تبويب الحالة
  const [tabIndex, setTabIndex] = useState(0);

  // REPLACED: useEffect الذي كان يجلب الموظفين عند التركيب
  // حذف useEffect القديم الذي كان يحتوي على mounted = true و load()

  // ADDED: دالة قابلة لإعادة الاستخدام لإعادة جلب الموظفين + mountedRef
  const mountedRef = useRef(true);

  const loadEmployees = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const res = await fetchEmployees();
      const flat = Array.isArray(res) ? res.flat(Infinity) : [];
      if (!mountedRef.current) return;
      setStaff(
        flat.map((e) => ({
          id: e.id,
          name: e.name,
          role: e.role,
          user_id: e.user_id ?? (e.user && (e.user.id ?? e.user.user_id)) ?? null,
          email: e.email,
          phone: e.phone,
          monthly_salary: e.monthly_salary,
          weekly_salary: e.weekly_salary,
          daily_salary: e.daily_salary,
          active: e.active,
          root_id: e.root_id ?? (e.root && e.root.id) ?? null,
          salary_type: e.salary_type ?? null,
          created_at: e.created_at,
          // NEW: remaining salary from API (fallbacks included)
          remaining_salary: e.remaining_salary ?? e.remainingSalary ?? e.remaining ?? 0,
        }))
      );
    } catch (err) {
      if (!mountedRef.current) return;
      setFetchError(err.message || "فشل في جلب الموظفين");
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    loadEmployees();
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // NEW: تحميل الفروع النشطة
  useEffect(() => {
    let mounted = true;
    const loadBranches = async () => {
      try {
        const res = await fetchActiveBranches();
        const list = Array.isArray(res) ? res : (res?.data && Array.isArray(res.data) ? res.data : []);
        if (!mounted) return;
        setBranches(list);
        const map = {};
        list.forEach((b) => {
          if (b && (b.id !== undefined)) map[b.id] = b.name ?? b.title ?? String(b.id);
        });
        setBranchesMap(map);
      } catch (err) {
        console.error("Failed to load branches:", err);
      }
    };
    loadBranches();
    return () => {
      mounted = false;
    };
  }, []);

  // NEW: تحميل المستخدمين (جلب أسماء المستخدمين لعرضها بدل id)
  useEffect(() => {
    let mounted = true;
    const loadUsers = async () => {
      try {
        const res = await getAllUsers();
        const list = Array.isArray(res) ? res : (res?.data && Array.isArray(res.data) ? res.data : []);
        if (!mounted) return;
        setUsers(list);
        const map = {};
        list.forEach((u) => {
          if (!u) return;
          // حاول استخدام الحقول الشائعة: name، username، full_name، أو fallback إلى id
          map[u.id] = u.name ?? u.username ?? u.full_name ?? String(u.id);
        });
        setUsersMap(map);
      } catch (err) {
        console.error("Failed to load users:", err);
      }
    };
    loadUsers();
    return () => { mounted = false; };
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setNewStaff({ name: "", role: "", status: "نشط" });
  };

  const handleChange = (e) => {
    setNewStaff({ ...newStaff, [e.target.name]: e.target.value });
  };

  const handleFormChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      setEmployeeForm((prev) => ({ ...prev, [name]: files && files[0] ? files[0] : null }));
    } else {
      // NEW: حول user_id و root_id إلى أرقام عند الاختيار (اترك فارغ كما هو)
      if ((name === "user_id" || name === "root_id") && value !== "") {
        const num = Number(value);
        setEmployeeForm((prev) => ({ ...prev, [name]: Number.isNaN(num) ? value : num }));
      } else {
        setEmployeeForm((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const handleSalaryChange = (e) => {
    const val = e.target.value;
    setEmployeeForm((prev) => {
      const key = `${prev.salary_type}_salary`;
      return { ...prev, [key]: val };
    });
  };

  const handleAddStaff = () => {
    if (newStaff.name && newStaff.role) {
      setStaff([...staff, { id: staff.length + 1, ...newStaff }]);
      handleClose();
    }
  };

  const handleOpenCreate = () => {
    setEmployeeForm({
      name: "",
      email: "",
      address: "",
      phone: "",
      role: "",
      monthly_salary: "",
      weekly_salary: "",
      daily_salary: "",
      salary_type: "monthly",
      user_id: "",
      root_id: "",
      nationa_id: null,
    });
    setOpen(true);
  };

  const handleSubmitEmployee = async () => {
    setSubmitLoading(true);
    try {
      const payload = { ...employeeForm };
      const res = await addEmployee(payload);
      // حاول إعادة جلب القائمة من الخادم لضمان تزامن البيانات
      await loadEmployees();
      setSnackbar({ open: true, message: "تم إنشاء الموظف بنجاح", severity: "success" });
      setOpen(false);
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: err.message || "فشل في إنشاء الموظف", severity: "error" });
    } finally {
      setSubmitLoading(false);
    }
  };

  const formatCreatedAt = (val) => {
    if (!val) return "-";
    try {
      const d = new Date(val);
      if (!isNaN(d.getTime())) {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }
      const s = String(val);
      return s.length >= 10 ? s.slice(0, 10) : s;
    } catch {
      return String(val).slice(0, 10);
    }
  };

  const getDisplayedSalary = (member) => {
    const type = member.salary_type || "monthly";
    const key = `${type}_salary`;
    return member[key] ?? member.monthly_salary ?? member.weekly_salary ?? member.daily_salary ?? "-";
  };

  // NEW: دالة للحصول على اسم الفرع من المعرف مع fallback
  const getBranchName = (id) => {
    if (!id && id !== 0) return "-";
    return branchesMap[id] ?? String(id);
  };

  // NEW: دالة للحصول على اسم المستخدم من المعرف مع fallback
  const getUserName = (id) => {
    if (id === null || id === undefined || id === "") return "-";
    return usersMap[id] ?? String(id);
  };

  // فتح نافذة التعديل وإرسال id الموظف
  const handleOpenEdit = (id) => {
    setEditEmployeeId(id);
    setEditOpen(true);
  };

  const handleCloseEdit = () => {
    setEditEmployeeId(null);
    setEditOpen(false);
  };

  // بعد الحفظ: تحديث قائمة staff (onSaved ينتج كائن الموظف المحدث إن وُجد)
  const handleSavedEdit = (updated) => {
    if (!updated || !updated.id) return;
    setStaff((prev) => prev.map((s) => (s.id === updated.id ? { ...s, ...updated } : s)));
  };

  // NEW: دالة مساعدة لتحديد النشاط (يدعم 1/0 أو true/false أو "1"/"0")
  const isActiveValue = (val) => {
    return val === 1 || val === "1" || val === true;
  };

  // NEW: قائمة مرشحة للعرض بناءً على التبويب
  const inactiveStaff = staff.filter((s) => !isActiveValue(s.active));
  const displayedStaff = tabIndex === 0 ? staff : inactiveStaff;

  const handleTabChange = (e, v) => setTabIndex(v);

  // فتح نافذة تفاصيل الموظف (JSON كامل)
  const handleOpenDetails = (member) => {
    setDetailData(member);
    setDetailOpen(true);
  };
  const handleCloseDetails = () => {
    setDetailOpen(false);
    setDetailData(null);
  };

  // فتح نافذة كشف الحساب وإرسال id
  const handleOpenAccount = (id) => {
    setAccountEmployeeId(id);
    setAccountOpen(true);
  };
  const handleCloseAccount = () => {
    setAccountEmployeeId(null);
    setAccountOpen(false);
  };

  // NEW: helper to present remaining salary with safe fallback
  const getRemainingSalary = (member) => {
    const val = member?.remaining_salary ?? member?.remainingSalary ?? member?.remaining;
    if (val === null || val === undefined || val === "") return "-";
    return typeof val === "number" ? val : String(val);
  };

  // NEW: خريطة لتسمية أنواع الرواتب بالعربي ومساعد للعرض
  const SALARY_TYPE_LABELS = {
    monthly: "شهري",
    daily: "يومي",
    weekly: "أسبوعي",
  };
  const getSalaryTypeLabel = (type) => {
    if (!type) return "-";
    return SALARY_TYPE_LABELS[type] ?? type;
  };

  // NEW: export staff to CSV (Excel-friendly)
  const exportStaffToCSV = () => {
    if (!staff || staff.length === 0) {
      setSnackbar({ open: true, message: "لا يوجد بيانات للتصدير", severity: "info" });
      return;
    }
    const headers = ["الاسم","الدور","اسم المستخدم","البريد","الهاتف","الراتب","الرصيد المتبقي","نوع الراتب","الحالة","الفرع","تاريخ الإنشاء"];
    const rows = staff.map((m) => [
      m.name ?? "",
      m.role ?? "",
      getUserName(m.user_id),
      m.email ?? "",
      m.phone ?? "",
      getDisplayedSalary(m),
      getRemainingSalary(m),
      getSalaryTypeLabel(m.salary_type),
      isActiveValue(m.active) ? "نشط" : "غير نشط",
      getBranchName(m.root_id),
      formatCreatedAt(m.created_at),
    ]);
    const csv = [headers, ...rows]
      .map(r => r.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","))
      .join("\r\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "employees.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    setSnackbar({ open: true, message: "تم تنزيل ملف التصدير", severity: "success" });
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4">👥 إدارة الموظفين</Typography>

      {/* NEW: Tabs */}
      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mt: 2 }}>
        <Tab label="كل الموظفين" />
        <Tab label="الحسابات الغير نشطة" />
      </Tabs>

      {loading ? (
        <Box sx={{ mt: 3, textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : fetchError ? (
        <Typography color="error" sx={{ mt: 2 }}>{fetchError}</Typography>
      ) : null}

      <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={handleOpenCreate}>
        إضافة موظف جديد
      </Button>

      <Button variant="outlined" color="primary" sx={{ mt: 2, ml: 2 }} onClick={exportStaffToCSV}>
        تصدير إلى Excel
      </Button>

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>الاسم</TableCell>
              <TableCell>الدور</TableCell>
              <TableCell>اسم المستخدم</TableCell>
              <TableCell>البريد</TableCell>
              <TableCell>الهاتف</TableCell>
              <TableCell>الراتب</TableCell>
              {/* NEW: عمود الرصيد المتبقي */}
              <TableCell>الرصيد المتبقي</TableCell>
              <TableCell>نوع الراتب</TableCell>
              <TableCell>الحالة</TableCell>
              <TableCell>الفرع</TableCell>
              <TableCell>تاريخ الإنشاء</TableCell>
              <TableCell>إجراءات</TableCell>
              {/* NEW: عمود عرض البيانات الكاملة يظهر في تاب الحسابات الغير نشطة */}
              {tabIndex === 1 && <TableCell>البيانات الكاملة</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedStaff.map((member) => (
              // CHANGED: اجعل الصف قابلاً للنقر لفتح كشف الحساب
              <TableRow
                key={member.id}
                onClick={() => handleOpenAccount(member.id)}
                sx={{ cursor: "pointer" }}
              >
                {/* ...existing cells... */}
                <TableCell>{member.name}</TableCell>
                <TableCell>{member.role}</TableCell>
                <TableCell>{getUserName(member.user_id)}</TableCell>
                <TableCell>{member.email || "-"}</TableCell>
                <TableCell>{member.phone || "-"}</TableCell>
                <TableCell>{getDisplayedSalary(member)}</TableCell>
                {/* NEW: عرض الرصيد المتبقي هنا */}
                <TableCell>{getRemainingSalary(member)}</TableCell>
                <TableCell>{getSalaryTypeLabel(member.salary_type)}</TableCell>
                <TableCell>{isActiveValue(member.active) ? "نشط" : "غير نشط"}</TableCell>
                <TableCell>{getBranchName(member.root_id)}</TableCell>
                <TableCell>{formatCreatedAt(member.created_at)}</TableCell>
                <TableCell>
                  {/* PREVENT ROW CLICK WHEN PRESSING EDIT */}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenEdit(member.id);
                    }}
                    aria-label="edit"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>

                {/* CHANGED: منع انتشار الحدث عند الضغط على عرض البيانات الكاملة */}
                {tabIndex === 1 && (
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenDetails(member);
                      }}
                    >
                      عرض
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog لإنشاء موظف جديد باستخدام API */}
      <Dialog
        open={open}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpen(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1 }}>
          <Box>إضافة موظف جديد</Box>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            size="small"
            sx={{ ml: 1 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField fullWidth label="اسم الموظف" name="name" variant="outlined" margin="dense" value={employeeForm.name} onChange={handleFormChange} />
          <TextField fullWidth label="البريد الإلكتروني" name="email" variant="outlined" margin="dense" value={employeeForm.email} onChange={handleFormChange} />
          <TextField fullWidth label="العنوان" name="address" variant="outlined" margin="dense" value={employeeForm.address} onChange={handleFormChange} />
          <TextField fullWidth label="الهاتف" name="phone" variant="outlined" margin="dense" value={employeeForm.phone} onChange={handleFormChange} />
          <TextField fullWidth label="الدور" name="role" variant="outlined" margin="dense" value={employeeForm.role} onChange={handleFormChange} />

          {/* CHANGED: عرض قائمة المستخدمين للاختيار بدلاً من حقل نصي */}
          <TextField
            select
            fullWidth
            label="المستخدم"
            name="user_id"
            variant="outlined"
            margin="dense"
            value={employeeForm.user_id || ""}
            onChange={handleFormChange}
          >
            <MenuItem value="">-- اختر مستخدم --</MenuItem>
            {users.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                {usersMap[u.id] ?? u.name ?? u.username ?? String(u.id)}
              </MenuItem>
            ))}
          </TextField>

          {/* NEW: حقل اختيار الفرع - يعرض أسماء الفروع، يكتب root_id */}
          <TextField
            select
            fullWidth
            label="الفرع"
            name="root_id"
            variant="outlined"
            margin="dense"
            value={employeeForm.root_id || ""}
            onChange={handleFormChange}
          >
            <MenuItem value="">-- اختر فرع --</MenuItem>
            {branches.map((b) => (
              <MenuItem key={b.id} value={b.id}>
                {b.name ?? b.title ?? String(b.id)}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="نوع الراتب"
            name="salary_type"
            variant="outlined"
            margin="dense"
            value={employeeForm.salary_type}
            onChange={handleFormChange}
          >
            <MenuItem value="monthly">{SALARY_TYPE_LABELS.monthly}</MenuItem>
            <MenuItem value="daily">{SALARY_TYPE_LABELS.daily}</MenuItem>
            <MenuItem value="weekly">{SALARY_TYPE_LABELS.weekly}</MenuItem>
          </TextField>

          {/* حقل ديناميكي واحد للراتب - اسمه المعروض "الراتب" */}
          <TextField
            fullWidth
            label="الراتب"
            variant="outlined"
            margin="dense"
            value={employeeForm[`${employeeForm.salary_type}_salary`] || ""}
            onChange={handleSalaryChange}
          />

          <Box sx={{ mt: 1 }}>
            <input type="file" name="nationa_id" accept="image/*" onChange={handleFormChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          {/* لا يوجد زر إلغاء — الإغلاق فقط عبر أيقونة الإغلاق أو زر الإنشاء */}
          <Button onClick={handleSubmitEmployee} color="secondary" variant="contained" disabled={submitLoading}>
            {submitLoading ? <CircularProgress size={20} /> : "إنشاء"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* NEW: مكون تعديل الموظف - يفتح عند الضغط على زر التعديل */}
      <EditeEmployeeData
        open={editOpen}
        employeeId={editEmployeeId} // نرسل id الموظف حسب طلبك
        onClose={handleCloseEdit}
        onSaved={handleSavedEdit}
      />

      {/* NEW: مكون كشف حساب الموظف */}
      <EmployeeAccountStatement
        open={accountOpen}
        employeeId={accountEmployeeId}
        onClose={handleCloseAccount}
      />

      {/* NEW: Dialog لعرض البيانات الكاملة للموظف بشكل منسق */}
      <Dialog open={detailOpen} onClose={handleCloseDetails} maxWidth="md" fullWidth>
        <DialogTitle>بيانات الموظف الكاملة</DialogTitle>
        <DialogContent dividers>
          <Box component="pre" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 13 }}>
            {detailData ? JSON.stringify(detailData, null, 2) : "-"}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetails}>إغلاق</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>

    </Box>
  );
};

export default EmployeePage;
